// File: src/styles/dataGridStyles.ts

import {SxProps, Theme} from '@mui/material/styles';

export const dataGridStyles: SxProps<Theme> = {
    backgroundColor: 'rgba(30, 30, 30, 0.8)',
    backdropFilter: 'blur(15px)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: 2,
    '& .MuiDataGrid-cell': {
        borderColor: 'rgba(255, 255, 255, 0.1)',
        color: 'text.primary',
    },
    '& .MuiDataGrid-columnHeaders': {
        backgroundColor: 'rgba(255, 151, 0, 0.1)',
        borderColor: 'rgba(255, 255, 255, 0.1)',
        color: 'primary.main',
        fontWeight: 600,
    },
    '& .MuiDataGrid-row': {
        '&:hover': {
            backgroundColor: 'rgba(255, 151, 0, 0.1)',
        },
        '&.Mui-selected': {
            backgroundColor: 'rgba(255, 151, 0, 0.2)',
            '&:hover': {
                backgroundColor: 'rgba(255, 151, 0, 0.25)',
            },
        },
    },
    '& .MuiDataGrid-footerContainer': {
        borderColor: 'rgba(255, 255, 255, 0.1)',
    },
    '& .MuiTablePagination-root': {
        color: 'text.primary',
    },
    '& .MuiDataGrid-selectedRowCount': {
        color: 'primary.main',
    },
};
